import { Flex } from "@chakra-ui/react";
import React from "react";
import PrintFormat from "./PrintFormat";

function PrintPdf({
  takeoutCart,
  orderPrice,
  name,
  phone,
  address,
  method,
  currentInvoiceNumber,
  history,
  time,
  orderNote,
  table,
  skipCode,
  schedule,
  scheduledTime,
  sequenceNumber,
}) {
  return (
    <Flex width="100%">
      <Flex width="50%">
        <PrintFormat
          takeoutCart={takeoutCart}
          orderPrice={orderPrice}
          name={name}
          phone={phone}
          address={address}
          method={method}
          currentInvoiceNumber={currentInvoiceNumber}
          time={time}
          history={history}
          orderNote={orderNote}
          table={table}
          copy={true}
          skipCode={skipCode}
          schedule={schedule}
          scheduledTime={scheduledTime}
          sequenceNumber={sequenceNumber}
        ></PrintFormat>
      </Flex>
      <Flex width="50%">
        <PrintFormat
          takeoutCart={takeoutCart}
          orderPrice={orderPrice}
          name={name}
          phone={phone}
          address={address}
          method={method}
          currentInvoiceNumber={currentInvoiceNumber}
          time={time}
          history={history}
          orderNote={orderNote}
          table={table}
          copy={false}
          skipCode={skipCode}
          schedule={schedule}
          scheduledTime={scheduledTime}
          sequenceNumber={sequenceNumber}
        ></PrintFormat>
      </Flex>
    </Flex>
  );
}

export default PrintPdf;
